import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutUs.css"; // Custom CSS file for additional styling

const AboutUs = () => {
  return (
    <>
      <div class="p-4 breadcrumb-container">
        <ol class="breadcrumb text-center">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item"><a href="#">About Us</a></li>
        </ol>
      </div>

      <div className="container about-us" id="aboutUs">
        <div className="row align-items-center">
          <div className="col-md-6 text-center">
            <img
              src="./images/ani3.webp"
              alt="Balloon Decoration"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-bold">About Us</h2>
            <p className="text-muted">
              Welcome to <strong>Balloon Bliss</strong>, your go-to destination for
              stunning balloon decorations! We specialize in creating unique and
              breathtaking balloon setups for birthdays, weddings, corporate
              events, and more.
            </p>
            <p className="text-muted">
              Our team of skilled decorators is dedicated to bringing your vision
              to life with vibrant colors, elegant designs, and creative
              arrangements. Whether it's a grand celebration or an intimate
              gathering, we ensure every detail is perfect.
            </p>
            <p className="text-muted">Let’s make your event unforgettable!</p>
            <a href="/contact" className="btn mt-3" style={{ backgroundColor: "#ff66b2", color: "#fff", fontWeight: "bold" }}>
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
